var A = Object.defineProperty;
var P = (l, r, e) => r in l ? A(l, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[r] = e;
var d = (l, r, e) => P(l, typeof r != "symbol" ? r + "" : r, e);
import { DatasetController as v, Element as D, Chart as M } from "chart.js";
class b extends v {
  constructor(r, e) {
    super(r, e);
  }
}
d(b, "id", "map"), d(b, "defaults", {
  dataElementType: "polygon"
}), d(b, "overrides", {
  animations: !1,
  interaction: {
    mode: "nearest",
    intersect: !0
  },
  scales: {
    x: {
      display: !1
    },
    y: {
      display: !1
    }
  }
});
function R(l) {
  return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
}
var F = { exports: {} };
(function(l) {
  (function() {
    function r(t, i) {
      var n = t.x - i.x, y = t.y - i.y;
      return n * n + y * y;
    }
    function e(t, i, n) {
      var y = i.x, c = i.y, g = n.x - y, f = n.y - c;
      if (g !== 0 || f !== 0) {
        var m = ((t.x - y) * g + (t.y - c) * f) / (g * g + f * f);
        m > 1 ? (y = n.x, c = n.y) : m > 0 && (y += g * m, c += f * m);
      }
      return g = t.x - y, f = t.y - c, g * g + f * f;
    }
    function a(t, i) {
      for (var n = t[0], y = [n], c, g = 1, f = t.length; g < f; g++)
        c = t[g], r(c, n) > i && (y.push(c), n = c);
      return n !== c && y.push(c), y;
    }
    function o(t, i, n, y, c) {
      for (var g = y, f, m = i + 1; m < n; m++) {
        var _ = e(t[m], t[i], t[n]);
        _ > g && (f = m, g = _);
      }
      g > y && (f - i > 1 && o(t, i, f, y, c), c.push(t[f]), n - f > 1 && o(t, f, n, y, c));
    }
    function p(t, i) {
      var n = t.length - 1, y = [t[0]];
      return o(t, 0, n, i, y), y.push(t[n]), y;
    }
    function s(t, i, n) {
      if (t.length <= 2) return t;
      var y = i !== void 0 ? i * i : 1;
      return t = n ? t : a(t, y), t = p(t, y), t;
    }
    l.exports = s, l.exports.default = s;
  })();
})(F);
var W = F.exports;
const O = /* @__PURE__ */ R(W), u = [
  "rgb(54, 162, 235)",
  // blue
  "rgb(255, 99, 132)",
  // red
  "rgb(255, 159, 64)",
  // orange
  "rgb(255, 205, 86)",
  // yellow
  "rgb(75, 192, 192)",
  // green
  "rgb(153, 102, 255)",
  // purple
  "rgb(201, 203, 207)"
  // grey
], h = /* @__PURE__ */ u.map((l) => l.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
class T extends v {
  constructor(e, a) {
    super(e, a);
    d(this, "polygon", null);
  }
  drawPolygon(e) {
    var a = new google.maps.LatLngBounds();
    let o = [];
    e.data.length > 100 ? o = O(e.data.map((s) => ({ x: s[0], y: s[1] })), 0.1).map((s) => [s.x, s.y]) : o = e.data, o = o.map((s) => [parseFloat(s[0].toFixed(6)), parseFloat(s[1].toFixed(6))]), o.forEach(([s, t]) => {
      const i = new google.maps.LatLng(s, t);
      a.extend(i);
    }), this.polygon = new google.maps.Polygon({
      paths: o.map((s) => ({ lat: s[0], lng: s[1] })),
      fillColor: e.backgroundColor,
      strokeColor: e.borderColor,
      strokeWeight: e.borderWidth || 1
    });
    const p = this.chart.map;
    this.polygon.addListener("click", () => {
      const s = new google.maps.InfoWindow({
        content: `<h3 style="font-size: 16px; font-weight: bold; margin-top: 0px; margin-bottom: 0px">${e.label}</h3>`,
        ariaLabel: e.label
      });
      s.setPosition(a.getCenter()), s.open({
        map: p
      });
    }), this.polygon.setMap(p);
  }
  getDataset() {
    let e = this.chart.data.datasets[this.index];
    return {
      ...e,
      backgroundColor: e.backgroundColor || h[this.index % h.length],
      borderColor: e.borderColor || u[this.index % u.length]
    };
  }
  update(e) {
    var p;
    const a = this._cachedMeta, o = this.getDataset();
    (e === "show" || e === "default") && !this.polygon && !a.hidden ? this.drawPolygon(o) : (e === "hide" || e === "reset" || a.hidden) && this.polygon && ((p = this.polygon) == null || p.setMap(null), this.polygon = null);
  }
}
d(T, "id", "polygon"), d(T, "defaults", {
  dataElementType: "polygon"
}), d(T, "overrides", {
  animations: !1,
  interaction: {
    mode: "nearest",
    intersect: !0
  },
  scales: {
    x: {
      display: !1
    },
    y: {
      display: !1
    }
  }
});
class x extends v {
  constructor(e, a) {
    super(e, a);
    d(this, "points", []);
  }
  getDataset() {
    let e = this.chart.data.datasets[this.index];
    return {
      ...e,
      backgroundColor: e.backgroundColor || h[this.index % h.length],
      borderColor: e.borderColor || u[this.index % u.length]
    };
  }
  normalizeData(e) {
    return Array.isArray(e) && typeof e[0] == "number" && typeof e[1] == "number" ? [[e[0], e[1]]] : Array.isArray(e) && Array.isArray(e[0]) ? e : [];
  }
  drawPoints(e) {
    const a = this.chart.map;
    this.normalizeData(e.data).forEach((p) => {
      const s = new google.maps.LatLng(
        parseFloat(p[0].toFixed(6)),
        parseFloat(p[1].toFixed(6))
      ), t = new google.maps.Marker({
        position: s,
        map: a,
        title: e.label,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 8,
          fillColor: e.backgroundColor,
          strokeColor: e.borderColor,
          fillOpacity: 1,
          strokeWeight: e.borderWidth || 1
        }
      });
      t.addListener("click", () => {
        new google.maps.InfoWindow({
          content: `<h3 style="font-size: 16px; font-weight: bold; margin-top: 0px; margin-bottom: 0px">${e.label}</h3>`,
          ariaLabel: e.label
        }).open({
          anchor: t,
          map: a
        });
      }), this.points.push(t);
    });
  }
  clearPoints() {
    this.points.forEach((e) => e.setMap(null)), this.points = [];
  }
  update(e) {
    const a = this._cachedMeta, o = this.getDataset();
    (e === "show" || e === "default") && this.points.length === 0 && !a.hidden ? this.drawPoints(o) : (e === "hide" || e === "reset" || a.hidden) && this.points.length > 0 && this.clearPoints();
  }
}
d(x, "id", "marker"), d(x, "defaults", {
  dataElementType: "marker"
}), d(x, "overrides", {
  interaction: {
    mode: "nearest",
    intersect: !0
  },
  scales: {
    x: {
      display: !1
    },
    y: {
      display: !1
    }
  }
});
class w extends v {
  constructor(e, a) {
    super(e, a);
    d(this, "polyline", null);
  }
  drawLine(e) {
    var a = new google.maps.LatLngBounds();
    let o = [];
    e.data.length > 100 ? o = O(e.data.map((s) => ({ x: s[0], y: s[1] })), 0.1).map((s) => [s.x, s.y]) : o = e.data, o = o.map((s) => [parseFloat(s[0].toFixed(6)), parseFloat(s[1].toFixed(6))]), o.forEach(([s, t]) => {
      const i = new google.maps.LatLng(s, t);
      a.extend(i);
    }), this.polyline = new google.maps.Polyline({
      path: o.map((s) => ({ lat: s[0], lng: s[1] })),
      geodesic: !0,
      strokeColor: e.borderColor,
      strokeOpacity: 1,
      strokeWeight: e.borderWidth || 2
    });
    const p = this.chart.map;
    this.polyline.addListener("click", () => {
      const s = new google.maps.InfoWindow({
        content: `<h3 style="font-size: 16px; font-weight: bold; margin-top: 0px; margin-bottom: 0px">${e.label}</h3>`,
        ariaLabel: e.label
      });
      s.setPosition(a.getCenter()), s.open({
        map: p
      });
    }), this.polyline.setMap(p);
  }
  getDataset() {
    let e = this.chart.data.datasets[this.index];
    return {
      ...e,
      backgroundColor: e.backgroundColor || h[this.index % h.length],
      borderColor: e.borderColor || u[this.index % u.length]
    };
  }
  update(e) {
    var p;
    const a = this._cachedMeta, o = this.getDataset();
    (e === "show" || e === "default") && !this.polyline && !a.hidden ? this.drawLine(o) : (e === "hide" || e === "reset" || a.hidden) && this.polyline && ((p = this.polyline) == null || p.setMap(null), this.polyline = null);
  }
}
d(w, "id", "polyline"), d(w, "defaults", {
  dataElementType: "polyline"
}), d(w, "overrides", {
  interaction: {
    mode: "nearest",
    intersect: !0
  },
  scales: {
    x: {
      display: !1
    },
    y: {
      display: !1
    }
  }
});
const S = [
  {
    elementType: "geometry",
    stylers: [
      {
        color: "#f5f5f5"
      }
    ]
  },
  {
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161"
      }
    ]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#f5f5f5"
      }
    ]
  },
  {
    featureType: "administrative.land_parcel",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#bdbdbd"
      }
    ]
  },
  {
    featureType: "administrative.neighborhood",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        color: "#eeeeee"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575"
      }
    ]
  },
  {
    featureType: "poi.business",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#e5e5e5"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: "#dadada"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161"
      }
    ]
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e"
      }
    ]
  },
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [
      {
        color: "#e5e5e5"
      }
    ]
  },
  {
    featureType: "transit.station",
    elementType: "geometry",
    stylers: [
      {
        color: "#eeeeee"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#c9c9c9"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e"
      }
    ]
  }
], z = [
  {
    elementType: "geometry",
    stylers: [
      {
        color: "#242f3e"
      }
    ]
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#746855"
      }
    ]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#242f3e"
      }
    ]
  },
  {
    featureType: "administrative.land_parcel",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#d59563"
      }
    ]
  },
  {
    featureType: "administrative.neighborhood",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#d59563"
      }
    ]
  },
  {
    featureType: "poi.business",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#263c3f"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#6b9a76"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        color: "#38414e"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#212a37"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9ca5b3"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: "#746855"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#1f2835"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#f3d19c"
      }
    ]
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [
      {
        color: "#2f3948"
      }
    ]
  },
  {
    featureType: "transit.station",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#d59563"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#17263c"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#515c6d"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#17263c"
      }
    ]
  }
], j = {
  id: "map",
  beforeInit: (l) => {
    if (typeof window < "u" && !l.map) {
      const r = l.canvas.parentElement;
      if (!r) return;
      const e = document.createElement("div");
      e.style.width = "100%", e.style.position = "absolute", e.style.top = "0px", e.style.bottom = "0px", e.style.borderRadius = "8px", r.appendChild(e);
      const a = l.options, o = new google.maps.Map(e, {
        zoom: 2,
        center: { lat: 0, lng: 0 },
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: !0,
        styles: a.theme === "light" ? S : z
      });
      l.map = o;
    }
  },
  beforeDraw: (l) => {
    l.map.getDiv().style.top = l.chartArea.top + "px";
  },
  afterUpdate: (l) => {
    const r = [], e = new google.maps.LatLngBounds(), a = l._metasets.map((o) => o.hidden);
    l.data.datasets.filter((o, p) => !a[p]).forEach((o) => {
      o.type === "marker" ? (Array.isArray(o.data[0]) ? o.data : [o.data]).forEach((s) => {
        const t = s[0], i = s[1];
        r.push(new google.maps.Marker({
          position: { lat: t, lng: i }
        }));
        const n = new google.maps.LatLng(t, i);
        e.extend(n);
      }) : o.type === "polyline" ? o.data.forEach(([p, s]) => {
        const t = new google.maps.LatLng(p, s);
        e.extend(t);
      }) : o.data.forEach(([p, s]) => {
        const t = new google.maps.LatLng(p, s);
        e.extend(t);
      });
    }), l.map.fitBounds(e);
  },
  defaults: {
    provider: "google"
  }
}, E = {
  backgroundColor: void 0,
  borderColor: void 0,
  borderWidth: void 0,
  borderRadius: 0,
  anchorX: "center",
  anchorY: "center",
  width: 20,
  height: 20
};
class k extends D {
  constructor(r) {
    super(), r && Object.assign(this, r);
  }
  draw(r) {
  }
}
d(k, "id", "marker"), d(k, "defaults", E);
class L extends D {
  constructor(r) {
    super(), r && Object.assign(this, r);
  }
  draw(r) {
  }
}
d(L, "id", "polyline"), d(L, "defaults", E);
class C extends D {
  constructor(r) {
    super(), r && Object.assign(this, r);
  }
  draw(r) {
  }
}
d(C, "id", "polygon"), d(C, "defaults", E);
M.register(b, T, x, w, L, k, C);
export {
  b as MapController,
  j as MapPlugin,
  x as MarkerController,
  k as MarkerElement,
  T as PolygonController,
  C as PolygonElement,
  w as PolylineController,
  L as PolylineElement
};
//# sourceMappingURL=index.js.map
